/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react';

interface DelayedSearchProps {
  value?: string | number | null;
  onSearch: (value: string) => void;
  placeholder?: string;
}

interface ChildProps {
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  value?: string | number | null;
  placeholder?: string;
}

export function withDelayedSearch<
  TProps extends DelayedSearchProps,
  TChildProps extends ChildProps,
>(Component: React.ComponentType<TChildProps>) {
  // Allows props to be forwarded from HOC to wrapped component
  return (props: TProps & Omit<TChildProps, keyof ChildProps>) => {
    const { onSearch, value, placeholder, ...rest } = props;
    const [query, setQuery] = useState(value?.toString() ?? '');

    useEffect(() => {
      const delayDebounceFn = setTimeout(() => {
        if (query) {
          onSearch(query);
        }
      }, 1500);

      return () => clearTimeout(delayDebounceFn);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [query]);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      const { value } = event.target;
      setQuery(value);
    };

    return (
      <Component
        {...(rest as unknown as TChildProps)}
        onChange={handleChange}
        value={query}
        placeholder={placeholder}
      />
    );
  };
}
